import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.SecondLevelMobile = function (element) {
        this.$dropdown = $('.dropdown');
        this.$dropDownMenu = $('.dropdownMenu');
        this.dropArrowOpened = $('.dropArrowOpened');
        this.dropArrowClosed = $('.dropArrowClosed');
        this.$dropdownIcon = this.dropArrowOpened.add(this.dropArrowClosed);
        this.dropWidth = 0;

        this.init();
    };

    OndigoNS.SecondLevelMobile.prototype = {
        init: function () {
            var _instance = this;
            this.$dropdown.add(this.$dropdownIcon).on('click', function(e) {
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                    if ($(e.target).parent().hasClass('active')) {
                        e.preventDefault();
                    }
                    _instance.handleDropdown(e);
                }
            });

            if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                this.updateDropWidth();
            }

            if (OndigoNS.Utils.hasTouchscreen()) {
                $(window).on('orientationchange', function () {
                    setTimeout(function () {
                        if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                            _instance.updateDropWidth();
                        }
                    }, 100);
                });
            }
            else {
                $(window).on('resize', function () {
                    setTimeout(function () {
                        if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                            _instance.updateDropWidth();
                        }
                    }, 100);
                });
            }
        },
        handleDropdown: function(e) {
            if ($(e.target).hasClass('active')) {
                e.preventDefault();
            }

            this.$dropdown.toggleClass('opened');
        },
        updateDropWidth: function() {
            // show it to get correct width
            $('.secondLevelMobile').removeClass('hideOnDesktop');
            this.$dropdown.addClass('opened');
            this.dropWidth = this.$dropDownMenu.innerWidth();

            if (this.$dropDownMenu.innerWidth() >= this.$dropdown.innerWidth()) {
                this.$dropdown.css('width', this.dropWidth - parseInt(this.$dropdown.css('padding-left')) - parseInt(this.$dropdown.css('padding-right')));
                this.$dropDownMenu.css('width', this.$dropdown.innerWidth());
            }
            else {
                this.$dropDownMenu.css('width', this.$dropdown.innerWidth());
            }
            this.$dropdown.removeClass('opened');
            $('.secondLevelMobile').addClass('hideOnDesktop');
        }
    };
    // plugin definition
    $.fn.secondLevelMobile = function () {
        return new OndigoNS.SecondLevelMobile(this);
    };
    $.fn.secondLevelMobile.Constructor = OndigoNS.SecondLevelMobile;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $secondLevelMobile = $('.secondLevelMobile');
    if ($secondLevelMobile.length) {
        $secondLevelMobile.secondLevelMobile();
    }
});